import React, { useContext } from 'react';
import { Layout } from 'antd';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';

// import { UserAccessContext } from 'context/userAccess';
import Login from 'modules/login';
import ChangePassword from 'modules/login/changePassword';
import ErrorPage from 'modules/error_page';
import PrivateRoute from 'shared_components/private_route';
import Home from "modules/home"
import User from "modules/users/search"
import UpdateUser from "modules/users/update_user"
import AddUser from "modules/users/add_user"
import Agent from "modules/agents/search"
import AddAgent from "modules/agents/add_agent"
import UpdateAgent from "modules/agents/update_agent"
import Customer from "modules/customers/search"
import AddCustomer from "modules/customers/add_customer"
import UpdateCustomer from "modules/customers/update_customer"
import InvoiceSearch from "modules/invoices/search";
import InvoiceDataEntry from "modules/invoices/data_entry";
import DetailsPage from "modules/invoices/details_update";
import PaymentsDataEntry from "modules/payments/payments_data_entry"
import PaymentSearch from "modules/payments/search/index";
import UpdatePayment from "modules/payments/details_update/index"
import SetupMaintenanceMenu from "modules/setup_maintenance";
import DeliverySearch from "modules/delivery/search";
import DeliveryDataEntry from "modules/delivery/delivery_data_entry";
import DeliveryUpdate from "modules/delivery/details_update";
import BoilerPlate from 'modules/boilerplate';
import AccountingReports from "modules/accounting_reports/";
import DrReports from "modules/dr_reports/";
import LookupTable from "modules/lookup_table/";
import SystemSetup from 'modules/system_setup';

import { BackgroundImage } from 'images';

const { Content: Antcontent } = Layout;
const wrapperStyle = {
	backgroundImage: `url(${BackgroundImage})`,
	backgroundSize: 'cover',
	backgroundRepeat: 'no-repeat'
};

function Content() {
	// const { userAccess } = useContext(UserAccessContext);

	return (
		<Antcontent style={wrapperStyle}>
			<Switch>
				<Route exact path="/" render={() => <Redirect to="/home" />} />
				<Route path="/login" component={Login} />
				<PrivateRoute path="/change_password" component={ChangePassword} />
				<PrivateRoute path="/home" component={Home} />
				<PrivateRoute path="/user/search" component={User} />
				<PrivateRoute path="/user/add_user" component={AddUser} />
				<PrivateRoute path="/user/update_user" component={UpdateUser} />
				<PrivateRoute path="/agent/search" component={Agent} />
				<PrivateRoute path="/agent/add_agent" component={AddAgent} />
				<PrivateRoute path="/agent/update_agent" component={UpdateAgent} />
				<PrivateRoute path="/customer/search" component={Customer} />
				<PrivateRoute path="/customer/add_customer" component={AddCustomer} />
				<PrivateRoute path="/customer/update_customer" component={UpdateCustomer} />
				<PrivateRoute path="/invoice/search" component={InvoiceSearch} />
				<PrivateRoute path="/invoice/data_entry" component={InvoiceDataEntry} />
				<PrivateRoute path="/invoice/details_update" component={DetailsPage} />
				<PrivateRoute path="/payment/search" component={PaymentSearch} />
				<PrivateRoute path="/payment/data_entry" component={PaymentsDataEntry}/>
				<PrivateRoute path="/payment/update_payment" component={UpdatePayment} />
				<PrivateRoute path="/accounting_reports/generate" component={AccountingReports} />
				<PrivateRoute path="/dr_reports/generate" component={DrReports} />
				<PrivateRoute path="/setup_maintenance" component={SetupMaintenanceMenu}/>
				<PrivateRoute path="/delivery/search" component={DeliverySearch}/>
				<PrivateRoute path="/delivery/data_entry" component={DeliveryDataEntry}/>
				<PrivateRoute path="/delivery/details_update"  component={DeliveryUpdate}/>
				<PrivateRoute path="/boilerplate" component={BoilerPlate} />
				<PrivateRoute path="/lookuptable" component={LookupTable} />
				<PrivateRoute path="/system_setup" component={SystemSetup} />
				<Route component={ErrorPage} />
				{/* <Route path="/home" component={Home} />
				<Route path="/user/search" component={User} />
				<Route path="/user/add_user" component={AddUser} />
				<Route path="/user/update_user" component={UpdateUser} />
				<Route path="/agent/search" component={Agent} />
				<Route path="/agent/add_agent" component={AddAgent} />
				<Route path="/agent/update_agent" component={UpdateAgent} />
				<Route path="/customer/search" component={Customer} />
				<Route path="/customer/add_customer" component={AddCustomer} />
				<Route path="/customer/update_customer" component={UpdateCustomer} />
				<Route path="/invoice/search" component={InvoiceSearch} />
				<Route path="/invoice/data_entry" component={DataEntry} />
				<Route path="/invoice/details_update" component={DetailsPage} />
				<Route path="/payment/search" component={PaymentSearch} />
				<Route path="/payment/data_entry" component={PaymentsDataEntry}/>
				<Route path="/setup_maintenance" component={SetupMaintenanceMenu}/>
				<Route path="/delivery/search" component={DeliverySearch}/>
				<Route path="/delivery/data_entry" component={DeliveryDataEntry}/>
				<Route component={ErrorPage} /> */}
			</Switch>
		</Antcontent>
	);
}


export default withRouter(Content);
